import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';
import colorPalette from './colorPalette'

let theme = createTheme({
  palette: {
    primary: {
      light: colorPalette.primary,
      main: colorPalette.primary,
      dark: colorPalette.primary,
      contrastText: '#fff',
    },
    secondary: {
      light: colorPalette.secondary,
      main: colorPalette.secondary,
      dark: colorPalette.secondary,
      contrastText: '#fff',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 321,
      md: 425,
      lg: 768,
      xl: 1024,
    },
  },
  typography: {
    htmlFontSize: 10,
    h1: {
      fontSize: 36,
      textAlign: 'center',
      fontWeight: 400,
      padding: '32px 0',
    },
    h2: {
      fontSize: 24,
      fontWeight: 400,
    },
    h3: {
      fontSize: 20,
      fontWeight: 400,
    },
    h4: {
      fontSize: 18,
      fontWeight: 400,
    },
    h5: {
      fontSize: 16,
      fontWeight: 400,
    },
    h6: {
      fontSize: 14,
      fontWeight: 400,
    },
    button: {
      textTransform: "none"
    },
    MuiTypography: {
      root: {
        fontSize: '1rem',
      }
    },
  },
  props: {
    MuiCheckbox: {
      color: "primary"
    },
    MuiRadio: {
      color: "primary"
    },
    MuiSwitch: {
      color: "primary"
    },
    MuiTextField: {
      variant: "outlined"
    }
  },
});
export default theme = responsiveFontSizes(theme);
